<template>
  <div class="common-layout">
    <el-container class="app-shell">
      <!-- 小程序 web-view 内嵌（embed=1）：隐藏顶部导航栏（RONGDE logo/主题/语言按钮）与用户信息栏，仅保留在线文档功能 -->
      <el-header v-if="!isHideHeader" class="common-header flex-flaot">
        <div class="flex">
          <img src="../assets/LogoR.jpg" alt="" class="logo" />
          <h1 class="header-title">RONGDE</h1>
        </div>
        <div class="head flex">
          <div class="flex theme-group">
            <el-button class="theme-btn" :title="theme === 'dark' ? '切换浅色主题' : '切换深色主题'" @click="toggleTheme">
              <el-icon><Moon v-if="theme === 'light'" /><Sunny v-else /></el-icon>
            </el-button>
          </div>
          <div class="flex lang-group">
            <el-button class="lang-btn" @click="setLang(lang === 'zh' ? 'en' : 'zh')">
              {{ lang === 'zh' ? 'English' : '中文' }}
            </el-button>
          </div>
          <el-dropdown trigger="click" @command="handleUserCommand" class="user-dropdown">
            <div class="user-trigger">
              <img :src="userInfo.avatarUrl" alt="" class="head_img" />
              <span style="color: var(--header-text); line-height: 14px;">
                <h1 style="display: inline-block; margin:0 .1875rem; font-weight: normal; font-size: 14px;">
                  {{userInfo.userName}}
                </h1>
              </span>
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item disabled>{{ userInfo.userName }}</el-dropdown-item>
                <el-dropdown-item command="logout" divided>
                  <el-icon><SwitchButton /></el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>
      <el-container class="app-body">
        <el-aside  v-if="!isEmbed" class="common-aside">
            <el-menu default-active="2" class="el-menu-vertical-demo" :router="true">
              <el-menu-item index="/">
                <el-icon>
                  <HomeFilled />
                </el-icon>
                {{ $t("menu.main") }}
              </el-menu-item>
              <el-sub-menu index="1">
                <template #title>
                  <el-icon>
                    <Menu />
                  </el-icon>
                  <span>{{ $t("menu.priojectM") }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="/project">{{ $t("menu.prioject") }}</el-menu-item>
                  <el-menu-item index="/devProject">{{ $t("menu.devProject") }}</el-menu-item>
                  <el-menu-item index="/approval">型式认可</el-menu-item>
                  <!-- <el-menu-item index="/projectStatistics">{{ $t("menu.projectStatistics") }}</el-menu-item> -->
                </el-menu-item-group>
              </el-sub-menu>
              <el-sub-menu index="4">
                <template #title>
                  <el-icon>
                    <House />
                  </el-icon>
                  <span>{{ $t("menu.personal") }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="/workRecord">
                    <el-icon>
                      <Notebook />
                    </el-icon>
                    {{ $t("menu.workRecord") }}
                  </el-menu-item>
                </el-menu-item-group>
              </el-sub-menu>

              <el-sub-menu index="6">
                <template #title>
                  <el-icon>
                    <Collection />
                  </el-icon>
                  <span>知识库</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="/onlineOffice">
                    <el-icon>
                      <EditPen />
                    </el-icon>
                    在线文档
                  </el-menu-item>
                </el-menu-item-group>
              </el-sub-menu>

              <el-sub-menu index="5">
                <template #title>
                  <el-icon>
                    <Setting />
                  </el-icon>
                  <span>{{ $t("menu.system") }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="/user">

                    <el-icon>
                      <User />
                    </el-icon>
                    {{ $t("menu.sUserM") }}
                  </el-menu-item>
                  <el-menu-item index="/roles">
                    <el-icon>
                      <Avatar />
                    </el-icon>{{ $t("menu.sRoleM") }}
                  </el-menu-item>
                  <el-menu-item index="/department">
                    <el-icon>
                      <OfficeBuilding />
                    </el-icon>
                    {{ $t("menu.sDepartmentM") }}
                  </el-menu-item>
                  <el-menu-item v-if="isAdmin" index="/serverLogs">
                    <el-icon><WarningFilled /></el-icon>
                    服务器日志
                  </el-menu-item>
                    <el-menu-item index="/look" @click="reload">
                     <el-icon><FullScreen /></el-icon>
                    {{ $t("menu.lookkb") }}
                  </el-menu-item>
                </el-menu-item-group>
              </el-sub-menu>
            </el-menu>
        </el-aside>
        <el-main class="main_content">
            <router-view  />
          </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import { reactive, toRefs, nextTick, ref, onMounted, computed } from "vue"
  import { useStore } from "vuex"
  import { useRouter, useRoute } from "vue-router"
  import { useI18n } from 'vue-i18n'
    import {getpriorityListApi,getUserListAllApi, logoutApi} from '@/util/request'

  export default {
    name: "LayOut",

    setup() {
      const store = useStore()
      const { locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      // 小程序 web-view 内嵌模式（embed=1）：隐藏左侧菜单，最大化内容区（移动端适配）
      const isEmbed = computed(() => route.query.embed === '1')
      // 小程序内嵌（embed=1）时隐藏顶部 RONGDE 品牌区/用户信息栏（仅小程序显示生效，Web 端保留顶栏）
      const isHideHeader = computed(() => route.query.embed === '1')
      const data = reactive({
        // 防御：登录态缺失/结构异常时不报错（userInfo 兜底为空对象）
        userInfo: (store.state.userInfo.userInfo && store.state.userInfo.userInfo.user) || {},
        isCollapse: false,
        // isRouterAlive: true,
        lang: locale.value
      })
      const isAdmin = computed(() => Number(data.userInfo && data.userInfo.roleId) === 1)
      // provide ('reload',data.isRouterAlive)
     const  reload=()=> {
        data.isRouterAlive = false
        nextTick(()=> {
          data.isRouterAlive = true
        })
      }

      // 退出登录：调用后端 + 清除本地登录态 + 跳转登录页
      const loginOut = () => {
        logoutApi()
        localStorage.removeItem("userInfo");
        localStorage.removeItem("userLists");
        store.commit('userInfo/setUserInfo', {});
        router.push({
          path: '/login'
        })
      }
      // 用户下拉菜单命令处理
      const handleUserCommand = (cmd) => {
        if (cmd === "logout") {
          loginOut()
        }
      }
      //用户列表

      const getUserLists=()=>{
       getUserListAllApi({ currentPage: 0 }).then(res => {
       if(res){
       console.log("res:",res)
      localStorage.setItem("userLists", JSON.stringify(res))
      console.log("localStorage:",localStorage)

       }
      })
      }

      //优先级
        const getpriorityLists=()=>{
      getpriorityListApi().then(res => {
        if(res){
        localStorage.setItem("priorityLists", JSON.stringify(res))
        }
      })
      }
      // 切换语言（EN / 中）
      const setLang = (l) => {
        data.lang = l
        locale.value = l
        localStorage.setItem("lang", l)
      }
      // 主题切换（浅色 / 深色，深色参照 DeepSeek）
      const theme = ref(localStorage.getItem("theme") || "light")
      const applyTheme = (t) => {
        document.documentElement.classList.toggle("theme-dark", t === "dark")
        localStorage.setItem("theme", t)
      }
      onMounted(() => applyTheme(theme.value))
      const toggleTheme = () => {
        theme.value = theme.value === "dark" ? "light" : "dark"
        applyTheme(theme.value)
      }
      getUserLists()
      getpriorityLists()
      return {
        ...toRefs(data),
        loginOut,
        handleUserCommand,
        setLang,
        theme,
        toggleTheme,
        getUserLists,
        getpriorityLists,
        reload,
        isAdmin,
        isEmbed,
        isHideHeader
        // t
      }
    }
  }
</script>
<!-- <link :href="''+lang+''">  本地存储-->
<style lang="scss" scoped>
.common-layout{
  height: 100vh;
  height: 100dvh;
  min-height: 0;
  overflow: hidden;

  .app-shell {
    height: 100%;
    min-height: 0;
    overflow: hidden;

    .common-header {
        background-color: var(--header-bg);
        border-bottom: 1px solid var(--border);
        display: flex;
        height: 56px;
        flex: 0 0 56px;
        min-width: 0;
        .header-title {
            color: #1a6bff;
            margin: 0;
            font-size: 22px;
            font-weight: 700;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

          }
        .logo {
            height: 56px;
            width: auto;
            margin-right: .5rem;
            object-fit: contain;
          }
          .theme-group {
            margin-right: 8px;
          }
          .lang-group {
            margin-right: 16px;
          }
          .lang-btn,
          .theme-btn {
            height: 32px;
            padding: 0 10px;
            color: var(--header-text);
            background: transparent;
            border-color: transparent;
          }
          .theme-btn .el-icon {
            font-size: 20px;
          }
        .head {
            margin-left: auto;
            flex: 0 0 auto;
          }
          .head_img {
            width: 21px;
            height: 21px;
            margin-right: .3rem;
            border-radius: 50%;
          }
          .user-dropdown {
            cursor: pointer;
          }
          .user-trigger {
            display: flex;
            align-items: center;
          }
          .language {
            width: .25rem;
            height: .25rem;
          }
      }

     .app-body {
       flex: 1;
       min-height: 0;
       min-width: 0;
       overflow: hidden;
     }

     .common-aside {
       background-color: var(--side-bg);
       border-right: 1px solid var(--border);
       width: clamp(160px, 11vw, 210px);
       height: 100%;
       overflow-y: auto;
       :deep(.el-menu) {
         background-color: var(--side-bg);
         border-right: none;
       }
       :deep(.el-menu-item),
       :deep(.el-sub-menu__title) {
         color: var(--side-text);
       }
       :deep(.el-menu-item:hover),
       :deep(.el-sub-menu__title:hover) {
         background-color: var(--side-hover) !important;
         color: #ffffff !important;
       }
       :deep(.el-menu-item.is-active) {
         background-color: var(--side-active-bg) !important;
         color: var(--side-active) !important;
       }
     }
    .main_content{
      min-width: 0;
      min-height: 0;
      overflow: auto;
      border:0px solid red;
      padding: 0;
      margin:0.09rem;
    }

  }
}

@media (max-width: 768px) {
  .common-layout .app-shell {
    .common-header {
      padding-left: 10px;
      padding-right: 10px;

      .header-title {
        display: none;
      }

      .head > div:first-child {
        margin-right: 8px !important;
      }

    }
    // 窄屏隐藏左侧菜单（在线文档由 embed 模式进入时内容区最大化）
    .common-aside {
      display: none;
    }
  }
}








</style>
